import { IconGift, IconMail, IconUsers } from "@tabler/icons-react";
import Card from "../UI/Card";
import DataCard from "../UI/DataCard";
import Title from "../UI/Title";
import Text from "../UI/Text";
import Button from "../UI/Button";
import FeaturedIcon from "../UI/FeaturedIcon";
import StepBadge from "../UI/StepBadge";
import CopyToClipboard from "../UI/CopyToClipboard";
// @ts-expect-error pure js
import useAccount from "../../hooks/use-account";
import styles from "./ParrainageShow.module.css";

const STEPS = [
  {
    title: "Partagez votre lien",
    description:
      "Envoyez votre lien de parrainage à vos proches qui gèrent des locations.",
  },
  {
    title: "Votre filleul s'inscrit",
    description: "Il crée son compte Qalimo en passant par votre lien.",
  },
  {
    title: "Un mois offert chacun",
    description:
      "Dès qu'il souscrit un abonnement, vous gagnez tous les deux un mois offert.",
  },
];

export default function ParrainageShow() {
  const { account, filleuls } = useAccount();

  const referralLink = `${import.meta.env.VITE_FRONTEND_URL}/signup?referral=${
    account.id_parrainage
  }`;

  const mailtoHref = `mailto:?subject=${encodeURIComponent(
    "Découvre Qalimo pour gérer tes locations",
  )}&body=${encodeURIComponent(
    `Bonjour,\n\nJe te recommande Qalimo pour gérer tes locations. En créant ton compte avec mon lien de parrainage, nous recevons chacun un mois d'abonnement offert :\n\n${referralLink}`,
  )}`;

  return (
    <div className={styles.page}>
      <Card padding="lg" className={styles.hero}>
        <FeaturedIcon icon={IconGift} size="lg" />
        <div>
          <Title variant="kilo">Parrainez vos proches</Title>
          <Text>
            Un mois d'abonnement offert, pour vous comme pour votre filleul, à
            chaque parrainage.
          </Text>
        </div>
        <div className={styles.linkBlock}>
          <div className={styles.linkBox}>
            <Text
              as="div"
              weight="medium"
              color="primary"
              className={styles.link}
            >
              {referralLink}
            </Text>
            <CopyToClipboard
              toCopy={referralLink}
              variant="plain"
              color="primary"
            />
          </div>
          <Button
            variant="secondary"
            icon={IconMail}
            onClick={() => {
              window.location.href = mailtoHref;
            }}
          >
            Partager par e-mail
          </Button>
        </div>
      </Card>

      <div className={styles.stats}>
        <DataCard
          title="Filleuls inscrits"
          icon={IconUsers}
          value={String(filleuls.nb_comptes ?? 0)}
          subtitle="Comptes créés avec votre lien de parrainage"
        />
        <DataCard
          title="Mois gratuits cumulés"
          icon={IconGift}
          value={String(filleuls.nb_comptes_abonnes ?? 0)}
          subtitle="Vous gagnez un mois quand votre filleul s'abonne"
        />
      </div>

      <Card>
        <Title variant="kilo">Comment ça marche ?</Title>
        <ol className={styles.steps}>
          {STEPS.map((step, i) => (
            <li key={i} className={styles.step}>
              <StepBadge status="active" number={i + 1} />
              <div>
                <Text weight="bold">{step.title}</Text>
                <Text>{step.description}</Text>
              </div>
            </li>
          ))}
        </ol>
      </Card>
    </div>
  );
}
